import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { bootstrapAuth } from './lib/auth';

bootstrapAuth()
  .then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <App />,
    );
  })
  .catch((err) => {
    console.error('Failed to bootstrap auth:', err);
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <pre style={{ color: 'var(--text-1)', padding: 40 }}>Auth bootstrap failed: {String(err)}</pre>,
    );
  });